import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "@angular/fire/database";
import { BehaviorSubject, Subject, Observable, Subscription } from "rxjs";
import {
  AngularFireStorage,
  AngularFireUploadTask,
} from "angularfire2/storage";
import { authenticationService } from "../Authentication/authentication.service";
import { isUndefined } from "util";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { LoadingController } from "@ionic/angular";
import { resourceLimits } from "worker_threads";
import { environment } from "src/environments/environment.prod";

@Injectable({
  providedIn: "root",
})
export class CotationMrhService {
  subscrip: Subscription;
  uploadState = new BehaviorSubject<boolean>(false);
  primeBaseAnnuelle = new BehaviorSubject<any[]>([]);
  ListAccessoire = new BehaviorSubject<any[]>([]);
  PrimeTTC = new BehaviorSubject<any>(null);
  task: AngularFireUploadTask;

 
  private readonly API_URL_TEST =
    "http://localhost:5001/salix-90588/us-central1/app/primemrh";
  dataChange: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  loading: HTMLIonLoadingElement;
  constructor(
    private db: AngularFireDatabase,
    private storage: AngularFireStorage,
    private httpClient: HttpClient,
    private loadingController: LoadingController,
    private authentic: authenticationService
  ) {
    //this.getaccessoires('1000');
  }
  async postGaranties(objetData) {
    this.loading = await this.loadingController.create({
      message: "Calcul encours...",
      mode: "ios",
      duration: 30 * 1000,
      spinner: "bubbles",
    });

    const timer = setTimeout(() => {}, 30 * 1000);

    await this.loading.present();
    const httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json",
      }),
    };
    try {
      this.dataChange.next(null);
      const result = await this.httpClient.post<any>(
        environment.API_URL_PROD_MRH,
        objetData,
        httpOptions
      );
      result.subscribe(
        (data) => {
          if (data !== null) {
            this.dataChange.next(data);
            this.loading.dismiss();
          }
        },
        (error: HttpErrorResponse) => {
          console.log(error.name + " " + error.message);
        }
      );
    } catch (error) {
      console.log(error);
    }
  }
  calculPrime(garantie, garantieop) {
    let value = {
      periode: "12 mois",
      rub: "MULTIRISQUE",
      prime: 0,
      acc: 0,
      Taxe: 0,
      css: 0,
      dateEff: "", //myDateDep.split('T')[0],
      dateEx: "", //myDateFin.split('T')[0],
      Ttc: 0,
      open: false,
      type: "MULTIRISQUE",
    };

    const tblgaranties = [...garantie, ...garantieop];
    value.prime = tblgaranties
      .filter((e: any) => e.selected)
      .reduce((acc: number, curr: any) => acc + curr.prime, 0);

    if (value.prime > 1000) {
      value = this.calculAccessoire(value);

      const taxeInc = tblgaranties
        .filter((e: any) => e.selected && e.taxe === 0.3)
        .reduce((acc: number, curr: any) => acc + curr.prime * curr.taxe, 0);

      const taxeAut = tblgaranties
        .filter((e: any) => e.selected && e.taxe !== 0.3)
        .reduce((acc: number, curr: any) => acc + curr.prime * curr.taxe, 0);

      value.Taxe = Math.round(taxeInc + taxeAut + value.acc * 0.3);

      value.css = Math.round((value.prime + value.acc) * 0.01);

      value.Ttc = value.prime + value.acc + value.Taxe + value.css;
    }

    return value;
  }

  calculAccessoire(_objetNette: any): any {
    let myacc = 1500;
    this.ListAccessoire.subscribe((access) => {
      _objetNette.acc =
        _objetNette.prime != 0
          ? access.filter(
              (a) => a.min <= _objetNette.prime && a.max >= _objetNette.prime
            )[0].acc + myacc
          : 0;
    });
    return _objetNette;
  }

  getaccessoires(codeAss) {
    //+this.codeAssur
    this.db
      .list(`AccessoireMhr/${codeAss}`, (ref) => ref.orderByValue())
      .snapshotChanges(["child_added"])
      .subscribe((actions) => {
        const ListAccessoire = [];
        actions.forEach((action) => {
          ListAccessoire.push({
            acc: action.payload.exportVal().acc,
            min: action.payload.exportVal().min,
            max: action.payload.exportVal().max,
          });
        });
        this.ListAccessoire.next(ListAccessoire);
        //return ListAssreurs
      });
  }
  async insertNewMrh(mrh: any) {
    return await this.db
      .list(`Cotations/${this.authentic.profile.uid}/Mrh`)
      .push(mrh);
  }
}
